import { z } from 'zod';
import { RuleExtractionId } from '@/rules-management/domain/RuleExtraction.ts';

const ruleExtractionSchema = z.object({
  id: z.string(),
});

type RuleExtractionJson = z.infer<typeof ruleExtractionSchema>;

const jsonToRuleExtractionId = (json: RuleExtractionJson): RuleExtractionId =>
  RuleExtractionId.of(json.id);

export const parseJsonToRuleExtractionId = (json: unknown): RuleExtractionId =>
  jsonToRuleExtractionId(ruleExtractionSchema.parse(json));
